import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { lightGrey } from 'utils/colors';
import {
    heightPercentageToDP,
    isPhone,
    isTablet,
    isTabletOrWeb,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    content: {
        flex: 1,
        paddingHorizontal: isTablet ? 44 : 16,
        justifyContent: 'center',
        width: isPhone ? '100%' : widthPercentageToDP(520),
    },
    logoImage: {
        alignSelf: 'flex-start',
        marginBottom: isTablet ? 32 : 24,
    },
    title: {
        fontFamily: Fonts.main.bold,
        fontSize: 32,
        marginBottom: 16,
    },
    textStyle: {
        textAlign: 'left',
    },
    descriptionStyle: {
        lineHeight: isTabletOrWeb ? heightPercentageToDP(24) : 24,
    },
    submitButtonStyle: {
        ...(isTablet
            ? {
                  minWidth: 120,
                  width: 'auto',
                  alignSelf: 'flex-start',
                  marginTop: 32,
                  paddingVertical: 8,
                  paddingHorizontal: 18,
              }
            : {
                  position: 'absolute',
                  bottom: 0,
              }),
    },
    landingContainer: {
        maxWidth: 420,
        alignItems: 'center',
        marginHorizontal: 'auto',
    },
    landingTitle: {
        marginBottom: heightPercentageToDP(16),
    },
    landingBtnContainer: {
        marginTop: heightPercentageToDP(12),
        marginBottom: heightPercentageToDP(32),
    },
    landingBtn: {
        marginHorizontal: widthPercentageToDP(8),
    },
    landingSeparatorContainer: {
        marginBottom: heightPercentageToDP(32),
    },
    landingSeparator: {
        width: 270,
        height: 1,
        backgroundColor: lightGrey(0.2),
    },
    landingSeparatorText: {
        position: 'absolute',
        top: 0,
        right: '50%',
        // @ts-ignore
        transform: [{ translateY: '-50%' }],
        paddingHorizontal: 5,
    },
});

export const webStyles = StyleSheet.create({
    content: {
        marginHorizontal: 72,
        flex: 1,
        justifyContent: 'center',
        alignContent: 'space-between',
        width: widthPercentageToDP(506),
    },
    title: {
        fontFamily: Fonts.main.bold,
        fontSize: 32,
        marginBottom: 12,
    },
    descriptionStyle: {
        lineHeight: isTabletOrWeb ? heightPercentageToDP(24) : 24,
    },
    textStyle: {
        textAlign: 'left',
    },
    submitButtonStyle: {
        minWidth: 120,
        width: 'auto',
        alignSelf: 'flex-start',
        marginTop: 32,
        fontFamily: Fonts.main.bold,
    },
    logoImage: {
        alignSelf: 'flex-start',
        marginBottom: 16,
    },
});

export default styles;
